/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "../sharedStyles/base.scss.ngstyle";
import * as i1 from "./scope.component.scss.ngstyle";
import * as i2 from "@angular/core";
import * as i3 from "./scope.component";
var styles_ScopeComponent = [i0.styles, i1.styles];
var RenderType_ScopeComponent = i2.ɵcrt({ encapsulation: 3, styles: styles_ScopeComponent, data: {} });
export { RenderType_ScopeComponent as RenderType_ScopeComponent };
export function View_ScopeComponent_0(_l) { return i2.ɵvid(0, [(_l()(), i2.ɵeld(0, 0, null, null, 0, "slot", [], null, null, null, null, null))], null, null); }
export function View_ScopeComponent_Host_0(_l) { return i2.ɵvid(0, [(_l()(), i2.ɵeld(0, 16777216, null, null, 1, "mc-scope", [], null, null, null, View_ScopeComponent_0, RenderType_ScopeComponent)), i2.ɵdid(1, 49152, null, 0, i3.ScopeComponent, [i2.ViewContainerRef], null, null)], null, null); }
var ScopeComponentNgFactory = i2.ɵccf("mc-scope", i3.ScopeComponent, View_ScopeComponent_Host_0, { ready: "ready", getComponentReference: "getComponentReference", registerComponent: "registerComponent", unregisterComponent: "unregisterComponent", getComponent: "getComponent" }, { register: "register", unregister: "unregister" }, []);
export { ScopeComponentNgFactory as ScopeComponentNgFactory };
